<template>
    <div>
        <nav class="navbar is-primary">
        </nav>
    </div>
</template>
